/**
 * The query result holds the necessary data that extract from the fetch response.
 */
export class GraphQlQueryResult {
  constructor(code, reason, response) {
    this.code = code;
    this.reason = reason;
    this.response = response;
  }
}
class QueryResultCreator {}

/**
 * This class is responsible for creating a query result for a non-OK fetch response.
 */
export class NonOkQueryResultCreator extends QueryResultCreator {
  constructor(fetchResponse) {
    super();
    this.fetchResponse = fetchResponse;
  }
  makeQueryResult() {
    return new GraphQlQueryResult(this.fetchResponse.status, this.fetchResponse.statusText);
  }
}

/**
 * This class is responsible for creating a query result for a fetch response that contains general errors.
 */
export class GeneralQueryErrorResultCreator extends QueryResultCreator {
  constructor(errors) {
    super();
    this.errors = errors;
  }
  makeQueryResult() {
    const [{
      extensions
    }] = this.errors;
    const [{
      statusCode,
      errorType
    }] = Array.isArray(extensions) ? extensions : [extensions];
    return new GraphQlQueryResult(statusCode, errorType, {
      errors: this.errors.map(error => error.message)
    });
  }
}

/**
 * This class is responsible for creating a query result for a fetch response that missing the key attributes.
 */
export class MissingQueryDataResultCreator extends QueryResultCreator {
  constructor(fetchResponse) {
    super();
    this.fetchResponse = fetchResponse;
  }
  makeQueryResult() {
    return new GraphQlQueryResult(this.fetchResponse.status, this.fetchResponse.statusText, {
      errors: ['Received data has missing attributes']
    });
  }
}
export class QuerySuccessResultCreator extends QueryResultCreator {
  constructor(response, data) {
    super();
    this.response = response;
    this.data = data;
  }
}